import React from "react";
import SiteFooter from "../../general/components/layout/SiteFooter";
import SiteNavbar from "../../general/components/layout/SiteNavbar";
import { serviceDetails, serviceActions } from "../assets/serviciosDetalle";
import ServiceCta from "../components/ServiceCta";
import ServiceHero from "../components/ServiceHero";
import ServiceSection from "../components/ServiceSection";
import serviciosNavTheme from "../components/serviciosNavTheme";

const service = serviceDetails["wellness-corporativo"];

export default function WellnessCorporativo() {
    return (
        <div className="servicios servicio-detalle service-page-wellness-corporativo">
            <SiteNavbar activeSection="servicios" ctaLabel="Contactar" ctaHref={serviceActions.homeContact} navTheme={serviciosNavTheme} />
            <ServiceHero service={service} />
            {service.sections.map((section) => (
                <ServiceSection key={`${section.label}-${section.title}`} section={section} />
            ))}
            <ServiceCta service={service} />
            <SiteFooter/>
        </div>
    );
}
